import script from "./gene_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./gene_detail.vue?vue&type=script&setup=true&lang=js"

import "./gene_detail.vue?vue&type=style&index=0&id=1b64443f&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\项目\\褐飞虱\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b64443f"]])

export default __exports__